import { render, staticRenderFns } from "./protocolView.vue?vue&type=template&id=38056d58&scoped=true&"
import script from "./protocolView.vue?vue&type=script&lang=js&"
export * from "./protocolView.vue?vue&type=script&lang=js&"
import style0 from "./protocolView.vue?vue&type=style&index=0&id=38056d58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38056d58",
  null
  
)

export default component.exports